// 倒计时结束逻辑
import { useStore } from 'vuex'
import { Dialog } from 'vant'
import { useCommonSubmitEffect } from '@/effects/submitEffect'

export const useCommonCountDownEffect = () => {
  const store = useStore()

  const { handleSubmitClick } = useCommonSubmitEffect()
  const handleCountDown = async (answers, submitFlag) => {
    // 超时自动提交
    if (store.getters.getQuesSetting.submitType === 1) {
      Dialog({
        title: '提示',
        message: '时间到，试卷已自动提交'
      })
      await handleSubmitClick(answers)
      if (submitFlag) {
        submitFlag.value = false
      }
    } else {
      Dialog({
        message: '已超时'
      })
    }
  }

  return {
    handleCountDown
  }
}
